import { apiFetch } from '../apihelper' // Import the apiFetch helper
import Cookies from 'js-cookie'

export const loginUser = async (email, password) => {
  const response = await apiFetch('auth/login', {
    // Use relative path, base URL is handled by apiFetch
    method: 'POST',
    body: JSON.stringify({ email, password })
  })

  // Store the token in session storage
  // localStorage.setItem('token', response.token);
  const expiryDate = new Date(new Date().getTime() + 5 * 60 * 60 * 1000) // 5 hours

  //   Cookies.set('token', response.token, {
  //     secure: true,
  //     sameSite: 'None',
  //     expires: expiryDate
  //   })

  // Return the success message or any additional info
  return { message: 'Login successful', ...response }
}
